import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthContext = createContext({});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(() => localStorage.getItem('to_token'));

  const fetchMe = useCallback(async (tk) => {
    try {
      const r = await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${tk}` } });
      setUser(r.data);
    } catch {
      setUser(null);
      setToken(null);
      localStorage.removeItem('to_token');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Handle token from OAuth redirect
    const params = new URLSearchParams(window.location.search);
    const tk = params.get('token');
    if (tk) {
      localStorage.setItem('to_token', tk);
      setToken(tk);
      // clear token from URL
      const clean = window.location.pathname + window.location.hash;
      window.history.replaceState({}, document.title, clean);
      fetchMe(tk);
      return;
    }
    if (token) fetchMe(token);
    else setLoading(false);
  }, [token, fetchMe]);

  const loginDiscord = async () => {
    const r = await axios.get(`${API}/auth/discord/login`);
    window.location.href = r.data.url;
  };

  const logout = async () => {
    if (token) {
      try { await axios.post(`${API}/auth/logout`, {}, { headers: { Authorization: `Bearer ${token}` } }); } catch {}
    }
    localStorage.removeItem('to_token');
    setToken(null);
    setUser(null);
  };

  const refresh = async () => { if (token) await fetchMe(token); };

  const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};

  return (
    <AuthContext.Provider value={{ user, token, loading, loginDiscord, logout, refresh, authHeaders }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
